<script setup lang="ts">
import { type IdTitle } from '@itinerary/ItineraryModuleTypes';
import type { Radio } from '#imports';

interface IProps {
    items?: IdTitle[];
}
const { items = [] } = defineProps<IProps>();
const modelValue = defineModel<string | null>({ default: null });
const id = ref(Math.random().toString());
const radioItems = computed<Radio[]>(() =>
    items.map(item => ({
        label: item.title,
        value: item.id,
    }))
);
const clear = () => {
    modelValue.value = '';
};
defineExpose({ clear });
</script>

<template>
    <div>
        <mr-radio-button v-model="modelValue" :name="id" :radios="radioItems" />
    </div>
</template>

<style scoped lang="scss">
:deep(label) {
    font-size: 11px;
    color: usePalette($p-gray, $p-600);
    @include font-weight(bold);
}
</style>
